import keepRouteCurrent from "./keepRouteCurrent";
import navigateToRoute, { setVdir, getVdir } from "./navigateToRoute";
import type RouterOptions from "./RouterOptions";
import router from "./routerInstance";
import { getRegisterRouteFunction } from "./registerRoute";
import { trace } from "owa-trace";
import { onModuleClick, determineModule } from "owa-workloads";
import { resetLastProcessedRoute } from "./lastProcessedRoute";
import { initializeRouteHistory } from "./routeHistory";

const modulesThatTriedToLoad: Set<string> = new Set();

export async function initializeRouter(routerOptions: RouterOptions): Promise<void> {
    await registerRouterRoutes(routerOptions);
    
    trace.info(`Set initial vdir to ${routerOptions.vdir}`, "router");
    setVdir(routerOptions.vdir);
    router.configure({
        notfound: () => {
            // Load the requested module's routes, but only try each module once to avoid loops.
            const targetModule = determineModule();
            const targetModuleName = targetModule.toString().toLowerCase();
            const isDifferentModule = !getVdir().toLowerCase().startsWith(targetModuleName);
            if (isDifferentModule && !modulesThatTriedToLoad.has(targetModuleName)) {
                modulesThatTriedToLoad.add(targetModuleName);
                trace.info(`Init click module to ${targetModuleName}`, "router");
                onModuleClick(targetModule);
                resetLastProcessedRoute();
            }
            else {
                trace.info("RouteNotFound", "router");
                routerOptions.routeGenerator.then(generator => {
                    navigateToRoute(generator());
                });
            }
        },
        html5history: true,
        convert_hash_in_init: false,
        run_handler_in_init: true,
        strict: false,
        async: true,
    });
    
    initializeRouteHistory();
    router.init();
    
    if (!routerOptions.staticUrl) {
        routerOptions.routeGenerator.then(generator => {
            keepRouteCurrent(generator);
        });
    }
}

export function registerRouterRoutes(routerOptions: RouterOptions, registerAll?: boolean): Promise<void> {
    return routerOptions.registerRoutes(getRegisterRouteFunction(routerOptions.vdir, routerOptions.setModuleForVdir), registerAll);
}
